import Dinero from 'dinero.js';
import { DocType } from '~/pages/projectDetails/landRights/types';

export const parcelDataCost = {
  [DocType.PrelimTitleReport]: Dinero({ amount: 0 }),
  [DocType.ChainOfTitleReport]: Dinero({ amount: 1870 }),
  [DocType.MapReport]: Dinero({ amount: 0 }),
  [DocType.OpenLienReport]: Dinero({ amount: 765 }),
  [DocType.TransactionHistoryReport]: Dinero({ amount: 765 }),
};

export const singleTitleCost = Dinero({ amount: 550 });
